import { each } from 'lodash';

const ElasticMapper = (elasticResults: any, map?: any) => {
	return elasticResults.hits.map((hit: any) => {
		let row: any = {};

		// If a map is passed in, use that, otherwise, just default to the row being the hit._source
		if (map) {
			each(map, (reducer, key) => {
				row[key] = reducer(hit._source, hit); // the second argument is the raw hit, which might include a .highlight attribute
			});
		} else {
			row = {
				...hit._source,
				hit,
			};
		}
		return row;
	});
};

export default ElasticMapper;
